import React from "react";
import { Location } from "@navigation/Location";
import { TravelConfirmationEditPage } from "../TravelConfirmation/TravelConfirmationEditPage";

type Params = {
  bookingId: string;
  confirmationId: string;
};

export class TravelConfirmationViewLocation extends Location<Params> {
  render(): React.ReactElement<any> {
    return (
      <TravelConfirmationEditPage
        bookingId={this.params.bookingId}
        confirmationId={this.params.confirmationId}
      />
    );
  }

  toURI(): string {
    const { confirmationId, bookingId } = this.params;
    return `/bookings/${bookingId}/travel-confirmation/${confirmationId}`;
  }
}
